export type LanguageId = 'en' | 'fr';
export const SupportedLanguageIds: Readonly<[LanguageId, ...LanguageId[]]> = ['en', 'fr'] as const;

export type TranslationMap<T = string> = Record<LanguageId, T>;

export interface SupportedLanguageElement {
  id: LanguageId;
  name: string;
}

// DO NOT TOUCH ORDER
// Used to generate helper dialogs
// The first language in the array is our default language
export const SupportedLanguages: readonly Readonly<SupportedLanguageElement>[] = [
  {
    id: 'en',
    name: 'english',
  },
  {
    id: 'fr',
    name: 'french',
  },
];

export const DefaultLanguage = SupportedLanguages[0];
